var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdownIconResponsive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.513 18.8155C14.9182 18.8155 12.0938 16.0167 12.0938 12.4546C12.0938 8.89254 14.9182 6.09375 18.513 6.09375C22.1078 6.09375 24.9322 8.89254 24.9322 12.4546C24.9322 16.0167 22.1078 18.8155 18.513 18.8155ZM18.513 8.6381C16.3304 8.6381 14.6614 10.2919 14.6614 12.4546C14.6614 14.6173 16.3304 16.2712 18.513 16.2712C20.6955 16.2712 22.3645 14.6173 22.3645 12.4546C22.3645 10.2919 20.6955 8.6381 18.513 8.6381Z",
    fill: "#1D1D1F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.2161 21.3596C25.831 21.3596 25.5742 21.2323 25.3174 20.9779L22.1078 17.7975C21.5943 17.2886 21.5943 16.5253 22.1078 16.0164C22.6213 15.5075 23.3917 15.5075 23.9052 16.0164L27.1148 19.1969C27.6284 19.7057 27.6284 20.469 27.1148 20.9779C26.858 21.2323 26.6013 21.3596 26.2161 21.3596Z",
    fill: "#1D1D1F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.9528 21.3619H3.78385C3.01354 21.3619 2.5 21.8708 2.5 22.6341C2.5 23.3974 3.01354 23.9062 3.78385 23.9062H17.9528C18.7232 23.9062 19.2367 23.3974 19.2367 22.6341C19.2367 21.8708 18.7232 21.3619 17.9528 21.3619Z",
    fill: "#1D1D1F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.81629 13.7291H3.78385C3.01354 13.7291 2.5 14.238 2.5 15.0013C2.5 15.7646 3.01354 16.2734 3.78385 16.2734H7.81629C8.5866 16.2734 9.10014 15.7646 9.10014 15.0013C9.10014 14.238 8.5866 13.7291 7.81629 13.7291Z",
    fill: "#1D1D1F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.1097 6.09237H3.78385C3.01354 6.09237 2.5 6.60124 2.5 7.36454C2.5 8.12785 3.01354 8.63672 3.78385 8.63672H10.1097C10.88 8.63672 11.3936 8.12785 11.3936 7.36454C11.3936 6.60124 10.88 6.09237 10.1097 6.09237Z",
    fill: "#1D1D1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIconResponsive);
export default __webpack_public_path__ + "static/media/DropdownIconResponsive.40809d5cfe0302c7537b3fa2c81665d2.svg";
export { ForwardRef as ReactComponent };